import type { DataTag, QueryKey, UseQueryOptions } from '@tanstack/react-query'

import type { HTTPValidationErrorDTO } from '@capture/client-api/src/orval'
import type { ErrorType } from '@capture/client-api/src/orval/customInstance'

import { getQueryClient } from '.'

export async function queryWithCache<TData, TError = ErrorType<void | HTTPValidationErrorDTO>>({
    queryKey,
    queryFn,
}: UseQueryOptions<TData, TError, TData> & {
    queryKey: DataTag<QueryKey, TData, TError>
}): Promise<TData> {
    const queryClient = getQueryClient()

    // Try to get cached data first for instant navigation
    const queryState = queryClient.getQueryState(queryKey)

    if (queryState && queryState.data && !queryState.isInvalidated) {
        return queryState.data as TData
    }

    return queryClient.fetchQuery({
        queryKey,
        queryFn,
    })
}
